import React, { FC } from 'react';
import { DescriptionLabel } from '@src/components/DescriptionLabel';
import DescriptionItems from '@src/components/DescriptionItems';
import printSeniorities from '@src/util/printSeniorities';
import { OpeningSourceEnum, OpeningVisibilityEnum } from '@src/graphql/generated';
import { ScrapedOpeningInfoNotice } from './ScrapedOpeningInfoNotice';
import { SkillsReviewProps } from './props';
import './styles.scss';

export const SkillsReview: FC<SkillsReviewProps> = ({ opening }) => {
  const locations = opening.positionLocations?.length
    ? opening.positionLocations.map(({ shortName }) => shortName)
    : [];

  if (opening.isRemote) {
    locations.push('Remote');
  }

  const getVisibilityCopy = (visibility: OpeningVisibilityEnum): string => {
    if (visibility === OpeningVisibilityEnum.PUBLIC) {
      return 'Publicly listed';
    }

    return 'Unlisted';
  };

  return (
    <div className="skills-review">
      <div className="skills-review-left">
        {opening.company?.name && <DescriptionLabel description={opening.company?.name} label={locations.join(', ')} />}

        {opening.speciality?.name && <DescriptionLabel description={opening.speciality?.name} label="Speciality" />}

        {!!opening.seniorities?.length && (
          <DescriptionLabel description={printSeniorities(opening.seniorities)} label="Seniorities" />
        )}
      </div>

      <div className="skills-review-right">
        <DescriptionLabel description="Visibility" label={getVisibilityCopy(opening.visibility)} />

        {opening.source === OpeningSourceEnum.SCRAPER ? (
          <ScrapedOpeningInfoNotice openingId={opening.id} />
        ) : (
          opening.skills?.length && (
            <DescriptionItems
              description="Who works with"
              items={opening.skills?.map(skillItem => skillItem.skill.name)}
            />
          )
        )}
      </div>
    </div>
  );
};
